// extracted by mini-css-extract-plugin
export default {"subheading":"MemberGroups_subheading__76OyW","load-more":"MemberGroups_load-more__8ZCuP","load-error":"MemberGroups_load-error__-8RUd","empty":"MemberGroups_empty__+Wj1u"};